import { render, staticRenderFns } from "./createdTwo.vue?vue&type=template&id=a60772f8&scoped=true"
import script from "./createdTwo.vue?vue&type=script&lang=js"
export * from "./createdTwo.vue?vue&type=script&lang=js"
import style0 from "./createdTwo.vue?vue&type=style&index=0&id=a60772f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60772f8",
  null
  
)

export default component.exports